import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Component } from 'react';
import Screens from '..';
import { EVENT_TYPES } from '../../lib/analytics/constants';
import Logger from '../../lib/analytics/logger';
import AppBackgroundType from '../../utils/AppBackgroundType';
import QueryParamsProxy from '../../utils/queryParamProxy';
export var PAGE_SIZE = 8;

var TableGames = /*#__PURE__*/function (_Component) {
  _inherits(TableGames, _Component);

  var _super = _createSuper(TableGames);

  function TableGames(props) {
    var _this;

    _classCallCheck(this, TableGames);

    _this = _super.call(this, props);

    _this._getLivePanelList = function () {
      var gameRooms = _this.props.gameRooms;
      var panelList = [];

      if (gameRooms && gameRooms.gameList[0] && gameRooms.gameList[0].games) {
        panelList = gameRooms.gameList[0].games;
      }

      panelList = panelList.filter(function (game) {
        return !game.IS_HIDDEN;
      });
      var pagedGames = new Array(Math.ceil(panelList.length / PAGE_SIZE)).fill().map(function (currentPage, index) {
        return panelList.slice(index * PAGE_SIZE, (index + 1) * PAGE_SIZE);
      });
      var pageNumber = 0;

      _this.setState({
        panelList: panelList,
        numColumn: 1,
        pagedGames: pagedGames,
        pageNumber: pageNumber
      });
    };

    _this._itemClickHandler = function (id) {
      _this.props.setGameId(id);

      QueryParamsProxy.navigate(_this.props.navigation, Screens.Game, {
        gid: id
      });
    };

    _this.state = {
      panelList: [],
      numColumn: 0,
      pagedGames: [],
      pageNumber: 0
    };
    return _this;
  }

  _createClass(TableGames, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._getLivePanelList();

      this.props.setAppBackground(AppBackgroundType.TABLE_GAMES);
      Logger.sendEvent(EVENT_TYPES.GAME_ROOM_LOADED, {
        name: 'tableGames'
      });
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (nextProps.gameRooms !== this.props.gameRooms) {
        this._getLivePanelList();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.props.setAppBackground(AppBackgroundType.NORMAL);
    }
  }, {
    key: "render",
    value: function render() {
      var render = this.props.render;
      return render(_objectSpread(_objectSpread({}, this.state), this.props));
    }
  }]);

  return TableGames;
}(Component);

export { TableGames as default };